module.exports = __webpack_public_path__ + "static/media/profile-active.2856f2ce.svg";